import { Component, Input, Output, EventEmitter, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { ManagerService } from 'src/app/core';
import { HttpEventType, HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-document-proofs',
  templateUrl: './document-proofs.component.html',
  styleUrls: ['./document-proofs.component.scss']
})
export class DocumentProofsComponent implements OnInit, OnDestroy {

  @Input() data: any;
  @Input() isOpen: boolean = false;
  @Input() inline: boolean = false;
  @Output() closeModal = new EventEmitter<void>();

  constructor(private managerService: ManagerService) { }

  @ViewChild('fileInput') fileInput: any;
  showStatusScreen: boolean = true;
  showUploadDocScreen: boolean = false;
  showChatScreen: boolean = false;
  fileData: any = null;
  fileName: any = '';
  comments: any = '';
  docUploading: boolean = false;
  uploadProgress: any = null;
  docUploadSuccess: boolean = false;
  docUploadFailed: boolean = false;
  documentsList: any = {};
  selectedFileId: any = null;
  dataLoaded: boolean = false;
  chatData: any = {};

  ngOnInit() {
    
    this.getDocProofsList()
  };

  getDocProofsList() {
    this.managerService.getProofOfDocumentsList(this.data.userChallengeId).subscribe((data: any) => {
      this.documentsList = data;
      this.dataLoaded = true;
    }, (err: any) => {
      console.log(err)
      this.dataLoaded = true;
    });
  };

  getDocHistory(item: any) {
    return this.documentsList[item].slice(1);
  };

  getDocumentList() {
    return Object.keys(this.documentsList);
  }

  showUploadProofLayout() {
    this.showStatusScreen = false;
    this.showUploadDocScreen = true;
    this.showChatScreen = false;
    this.docUploadSuccess = false;
    this.docUploadFailed = false;
  };

  showDocStatusLayout() {
    this.showStatusScreen = true;
    this.showUploadDocScreen = false;
    this.showChatScreen = false;
    this.fileData = null;
  };

  upload() {
    const fileInputEl = document.getElementById("getFile");
    if (fileInputEl) {
      fileInputEl.click();
    }
  };

  getFile(eve: any) {
    this.fileData = eve.target.files[0];
    this.fileName = this.fileData.name;
    this.fileInput.nativeElement.value = '';
  };

  clearFile() {
    this.fileData = null;
    this.selectedFileId = null;
    this.comments = null;
    this.fileName = '';
  };

  closeDialog() {
    this.closeModal.emit();
  };

  openChatModal(fileData: any, docItem: any) {
    this.showStatusScreen = false;
    this.showUploadDocScreen = false;
    this.showChatScreen = true;
    this.chatData = {
      fileData: {...fileData, docName: docItem.key},
      userChallengeId: this.data.userChallengeId
    };
  };

  onChatScreenBack() {
    this.showStatusScreen = true;
    this.showUploadDocScreen = false;
    this.showChatScreen = false;
  };

  submitDocument() {
    this.docUploading = true;
    this.uploadProgress = 0;
    this.docUploadSuccess = false;
    this.docUploadFailed = false;
    const formData = new FormData();
    formData.append('file-to-be-uploaded', this.fileData);
    const params = '?fileName='+this.fileName+'&comment='+this.comments+'&docTypeId='+this.selectedFileId.id;
    this.managerService.acSubmitProofs(this.data.userChallengeId, formData, params).subscribe((data: any) => {
      if(data.type === HttpEventType.UploadProgress){
        this.uploadProgress = Math.round((100 / data.total) * data.loaded)
      }
      else if (data instanceof HttpResponse) {
        this.docUploading = false;
        this.docUploadSuccess = true;
        this.showStatusScreen = true;
        this.showUploadDocScreen = false;
        this.showChatScreen = false;
        this.getDocProofsList();
        this.clearFile();
        setTimeout(() => {
          this.docUploadSuccess = false;
        }, 5000);
      }
     },(_error: any)=>{
       this.docUploading = false;
       this.docUploadFailed = true;
     })
  };

  getLocalDate(data: any) {
    return data ? new Date(data).toLocaleDateString() : null
  };

  getFileType(fileName: any) {
    let fileImage = '<span class="icon-file-o"></span>'
    if (fileName) {
      const extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
      if (extension === 'pdf') {
        fileImage = '<span class="icon-file-pdf-o"></span>'
      }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') {
        fileImage = '<span class="icon-file-excel-o"></span>'
      }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        fileImage = '<span class="icon-file-image-o"></span>'
      }
    }
    return fileImage;
  };

  getClassByFileType(fileName: any) {
    let fileColor = ''
    if (fileName) {
      const extension = fileName.split('.')[fileName.split('.').length - 1].toLowerCase()
      if (extension === 'pdf') {
        fileColor = 'pdf-color'
      }
      if (extension === 'xls' || extension === 'xlsx' || extension === 'xlsm') {
        fileColor = 'excel-color'
      }
      if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
        fileColor = 'image-color'
      }
    }
    return fileColor;
  };



  ngOnDestroy(): void {
    const ciscoLinkElement = document.head.querySelector(`link[rel="stylesheet"].${'cisco_styles'}`);
    if (ciscoLinkElement) {
      document.head.removeChild(ciscoLinkElement);
    };
  };
}
